export const USER_ROLES = {
    ROLE_OUTDOOR_USER: 'ROLE_OUTDOOR_USER',
    ROLE_CONNECT_USER: 'ROLE_CONNECTUSER',
    ROLE_FITNESS_USER: 'ROLE_FITNESS_USER',
    ROLE_WELLNESS_USER: 'ROLE_WELLNESS_USER',
    ROLE_DIVE_USER: 'ROLE_DIVE_USER',
    ROLE_RACE_EVENT_PROVIDER: 'ROLE_RACE_EVENT_PROVIDER',
    ROLE_CONNECTBETAUSER: 'ROLE_CONNECTBETAUSER',
    ROLE_CHILD_USER: 'ROLE_USER_MANAGED_ACCOUNTS_CHILD',
    ROLE_ADMIN_USER: 'ROLE_USER_MANAGED_ACCOUNTS_ADMIN'
};

export const CHILD_ACCOUNT_MEMBER_TYPE = {
    ADMIN: 'ADMIN',
    CHILD: 'CHILD'
};
